<template>
  <div class="bar_chart" ref="barChart"></div>
</template>

<script>
const echarts = require('echarts');
export default {
    props:["opts"],
    watch:{
        opts(newObj) {
            if (newObj.xAxisData.length>0){
                let { xAxisData , serieObj , serieObj2 } = this.opts;
                this.drawBar(JSON.parse(JSON.stringify(xAxisData)),serieObj && JSON.parse(JSON.stringify(serieObj)),serieObj2 && JSON.parse(JSON.stringify(serieObj2)));
            }
        }
    },
    mounted(){
        let { xAxisData , serieObj , serieObj2 } = this.opts;
        this.drawBar(JSON.parse(JSON.stringify(xAxisData)),serieObj && JSON.parse(JSON.stringify(serieObj)),serieObj2 && JSON.parse(JSON.stringify(serieObj2)));
    },
    methods:{
        drawBar(xAxisData,serieObj,serieObj2){
            let itemChart = echarts.init(this.$refs.barChart);
            itemChart.setOption({
                legend:{
                    show:true,
                    right:"2%",
                    icon:'circle',
                    itemWidth:10,
                    itemHeight:10,
                    itemGap:30
                },
                xAxis: {
                    data: xAxisData,
                    type: "category",
                    axisLabel: {
                        color:"#2192ff",
                    }
                },
                yAxis: {
                    // show:false
                },
                grid: {
                    show: true,
                    backgroundColor: "rgba(250, 250, 250, .6)",
                    borderColor: "rgba(255, 255, 255, 1)",
                    left: "1%",
                    right: "1%", 
                    width: "98%",
                    height:"85%",
                    containLabel:true
                },
                animationDurationUpdate: 1000,
                series: [
                    serieObj && {
                        type: 'bar',
                        name:serieObj.name,
                        z: 10,
                        barWidth:25,
                        barMinHeight:1,
                        itemStyle: {
                            normal: {
                                color: serieObj2 ? new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                    [
                                        {offset: 0,color:'#65BFFF'}, //柱图渐变色
                                        {offset: 1, color:'#9beef4'} //柱图渐变色
                                    ]
                                ) : new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                    [
                                        {offset: 0,color:'#EE8F51'}, //柱图渐变色
                                        {offset: 1, color:'#FFDFA8'} //柱图渐变色
                                    ]
                                )
                            }
                        },
                        label: {
                            show: true,
                            position: 'top'
                        },
                        data: serieObj.data
                    },
                    serieObj2 && {
                        type: 'bar',
                        name:serieObj2.name,
                        barGap: '-100%',
                        barWidth:25,
                        barMinHeight:1,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0,color:'#EE8F51'}, //柱图渐变色
                                        {offset: 1, color:'#FFDFA8'} //柱图渐变色
                                    ]
                                )
                            }
                        },
                        label: {
                            show: true,
                            position: 'top'
                        },
                        data: serieObj2.data
                    }

                ]
            })
        }
    }
}
</script>

<style scoped>
    .bar_chart{
        width: 100%;
        height: 100%;
    }
</style>